import React from 'react';
import {Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

import { GlobalWorkerOptions } from 'pdfjs-dist';
import packageJson from 'pdfjs-dist/package.json';

import '@react-pdf-viewer/bookmark/lib/styles/index.css';

import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import {Typography} from "@mui/material";
import { blue } from '@mui/material/colors';


// Set worker URL dynamically based on the installed version
const pdfjsVersion = packageJson.version;
const workerUrl = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsVersion}/pdf.worker.min.js`;
GlobalWorkerOptions.workerSrc = workerUrl;

const PDFViewer = ({ fileUrl, width = '40vw', height = '80vh', paddingRight = '10px' }) => {

    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        toolbarPlugin: {
            fullScreenPlugin: {
                getFullScreenTarget: (pagesContainer) => pagesContainer.closest('[data-testid="default-layout__body"]'),
                renderExitFullScreenButton: (props) => <></>,
            },
        },
        // Customize the sidebar tabs
        sidebarTabs: (defaultTabs) => [
            defaultTabs[0], // Bookmarks tab
            defaultTabs[1], // Thumbnails tab
        ],
    });


    const plugins = [
        defaultLayoutPluginInstance,
    ];
    return (
        <div style={{height, width, paddingRight , backgroundColor: "white"}}>

            <Worker workerUrl={workerUrl}>
                <Viewer fileUrl={fileUrl} plugins={plugins} theme="auto"
                        renderError={() =>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '70%',
                                width: '100%',
                                textAlign: 'center'
                            }}>
                                <Typography variant="h6" color={blue[700]}>
                                    Still Loading PDF to the Server.
                                </Typography>
                            </div>

                        }

                />
            </Worker>
        </div>
    );
};

export default PDFViewer;
